module.exports = __webpack_public_path__ + "brandon_reg-webfont.476344256fe9480e1bd3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_reg-webfont.woff
// module id = 947
// module chunks = 7